import { defineComponent, reactive, toRefs, onMounted, onBeforeUnmount, nextTick, ref, watch, } from 'vue';
import { withInstall } from '../_util/type';
import Graph from './utils/graph';
import { getOffset, vector, //arrayReplace
 } from './utils';
import useConfigInject from '../_util/hooks/useConfigInject';
import GraphNode from './Node';
import GraphLine from './Link';
import { insertNode, appendNode, deleteNode, shrinkOrExpandNode, initShrinkNode, mergeNode, cancelMerge, lightenPath, changeNodeHeight, checkMergeNodeList, findNodeByCoordinate, appendDragNode, deleteDragNodeAndLink, updateDragNode, disabledNodeDrag, editMerge, } from './utils/tool';
import classNames from '../_util/classNames';
import ScrollBar from '../scrollbar';
import { QuotationColor } from '../_util/enum';
import raf from '../_util/raf';
// import { TreeNodeType } from './utils/types';
export const stgyFlowProps = () => ({
    relationMark: {
        type: String,
        default: 'id',
    },
    startMark: {
        type: String,
        default: 'startId',
    },
    endMark: {
        type: String,
        default: 'endId',
    },
    draggable: {
        type: Boolean,
        default: false,
    },
    // linkAddable: {
    //   type: Boolean,
    //   default: true,
    // },
    linkEditable: {
        type: Boolean,
        default: true,
    },
    // hasMarkLine: {
    //   type: Boolean,
    //   default: true,
    // },
    linkDesc: {
        type: Object,
        default: () => { },
    },
    linkStyle: {
        type: Object,
        default: () => {
            return {
                hover: '#FF0000',
                color: '#666666',
                textColor: '#666666',
                textHover: '#FF0000',
                font: '14px Arial',
                dotted: false,
                lineDash: [4, 4],
                background: 'rgba(255,255,255,0.6)',
            };
        },
    },
    linkBaseStyle: {
        type: Object,
        default: () => ({}),
    },
    markLineColor: {
        type: String,
        default: '#55abfc',
    },
    origin: {
        type: Array,
        default: () => [0, 0],
    },
    nodeList: {
        type: Array,
        default: () => [],
    },
    linkList: {
        type: Array,
        default: () => [],
    },
    modelPathList: {
        type: Array,
        default: () => [],
    },
    graphMenu: {
        type: Array,
        default: () => [],
    },
    nodeMenu: {
        type: Array,
        default: () => [],
    },
    linkMenu: {
        type: Array,
        default: () => [],
    },
    selectedNodeId: {
        type: Array,
        default: () => [],
    },
    selectedActiveId: {
        type: Number,
        default: -1,
    },
    linkPadding: {
        type: Number,
        default: 50,
    },
    enterIntercept: {
        type: Function,
        default: () => true,
    },
    outputIntercept: {
        type: Function,
        default: () => true,
    },
    merge: {
        type: Boolean,
        default: false,
    },
    menus: {
        type: Array,
        default: () => [],
    },
    readonly: {
        type: Boolean,
        default: false,
    },
    quotationColor: {
        type: Number,
        default: QuotationColor.RED_UP_GREEN_DOWN,
    },
});
const StgyFlow = defineComponent({
    compatConfig: { MODE: 3 },
    name: 'WdStgyFlow',
    props: stgyFlowProps(),
    emits: [
        'node-select',
        'node-delete',
        'node-insert',
        'link-select',
        'menu-click',
        'node-append',
        'node-append-before',
        'node-click',
    ],
    slots: ['node-header', 'node-content'],
    setup(props, { slots, emit, expose }) {
        const { prefixCls } = useConfigInject('stgy-flow', props);
        const { relationMark, startMark, endMark, origin, outputIntercept, 
        // linkAddable,
        // enterIntercept,
        draggable, 
        // hasMarkLine,
        linkEditable, nodeList, linkList, linkPadding, linkBaseStyle, linkDesc, linkStyle, selectedNodeId, selectedActiveId, merge, modelPathList, menus, readonly, quotationColor, } = toRefs(props);
        const state = reactive({
            graph: new Graph({
                relationMark: relationMark.value,
                startMark: startMark.value,
                endMark: endMark.value,
                origin: origin.value,
            }),
            menuConf: {
                visible: false,
                position: [0, 0],
                source: null,
                list: [],
            },
            moveNodeConf: {
                isMove: false,
                sourceNode: null,
                offset: null,
                verticalList: [],
                horizontalList: [],
                markLine: [],
                startNode: null,
                targetNode: null,
                direction: null,
                disabledDrag: false,
                disabledDragging: false, // 是否禁用拖动过程
            },
            moveAllConf: {
                isMove: false,
                downPosition: [0, 0],
                origin: [],
            },
            temEdgeConf: {
                visible: false,
                link: null,
            },
            loaded: false,
            clientWidth: 0,
            clientHeight: 0,
            flowRef: null,
            scrollRef: null,
            renderNodeList: [],
        });
        const { graph, menuConf, moveNodeConf, moveAllConf, temEdgeConf, 
        // clientWidth,
        // clientHeight,
        scrollRef, renderNodeList, } = toRefs(state);
        const flowRef = ref();
        onMounted(() => {
            document.addEventListener('mousedown', docMousedown);
            document.addEventListener('mousemove', docMousemove);
            nextTick(() => {
                handlerShrinkNode();
            });
        });
        onBeforeUnmount(() => {
            document.removeEventListener('mousedown', docMousedown);
            document.removeEventListener('mousemove', docMousemove);
        });
        watch(() => graph.value.mouseOnLink, () => {
            if (readonly.value)
                return;
            if (graph.value.mouseOnLink) {
                document.body.style.cursor = 'pointer';
            }
            else {
                document.body.style.cursor = '';
            }
        });
        watch(() => origin.value, () => {
            graph.value.origin = origin.value;
        });
        watch(() => nodeList.value, () => {
            handlerShrinkNode();
            updateContainerRect();
        }, {
            deep: true,
        });
        watch(() => linkList.value, () => {
            graph.value.initLink(linkList.value);
        }, {
            deep: true,
        });
        watch(() => modelPathList.value, () => {
            handlerShrinkNode();
        }, {
            deep: true,
        });
        const cacheWidth = 200;
        const cacheHeight = 100;
        const updateContainerRect = () => {
            const rect = renderNodeList.value?.reduce((prev, item) => {
                const [x, y] = item?.coordinate;
                const w = x + item.width || 0;
                if (w > prev.width) {
                    prev.width = w;
                }
                const h = y + item.height || 0;
                if (h > prev.height) {
                    prev.height = h;
                }
                return prev;
            }, {
                width: 0,
                height: 0,
            });
            const d = document.querySelector(`.${prefixCls.value}`);
            if (d) {
                d.style.width = `${rect.width + cacheWidth}px`;
                d.style.height = `${rect.height + cacheHeight}px`;
            }
        };
        const docMousedown = evt => {
            if (linkEditable.value) {
                graph.value.dispatch({
                    type: 'mousedown',
                    evt,
                }, true);
            }
        };
        let offsetX = 0;
        let offsetY = 0;
        let offsetLeft = 0;
        let offsetTop = 0;
        let draggableEl = null;
        let dragFlag = false;
        const nodeMousedown = (evt, node) => {
            evt.preventDefault();
            dragFlag = false;
            const boxEl = evt.target.closest(`.${prefixCls.value}-node`);
            const el = boxEl.children[0];
            offsetX = evt.clientX - el.getBoundingClientRect().left;
            offsetY = evt.clientY - el.getBoundingClientRect().top;
            moveNodeConf.value.disabledDrag = disabledNodeDrag({
                sourceNode: node,
                linkList: linkList.value,
                nodeList: nodeList.value,
                modelPathList: modelPathList.value,
                draggable: draggable.value,
            });
            if (!moveNodeConf.value.disabledDrag) {
                draggableEl = el.cloneNode(true);
                window.requestAnimationFrame(() => {
                    draggableEl.style.position = 'absolute';
                    draggableEl.style.zIndex = '10';
                    draggableEl.style.opacity = '0';
                    draggableEl.style.width = el.offsetWidth + 'px';
                    draggableEl.style.height = el.offsetHeight + 'px';
                    draggableEl && flowRef.value?.appendChild(draggableEl);
                });
            }
            moveNodeConf.value.sourceNode = node;
            document.addEventListener('mousemove', docNodeMove);
            document.addEventListener('mouseup', doceNodeUp);
        };
        const docMousemove = evt => {
            if (linkEditable.value) {
                graph.value.dispatch({
                    type: 'mousemove',
                    evt,
                }, true);
            }
        };
        const docNodeMove = evt => {
            evt.preventDefault();
            evt.stopPropagation();
            if (moveNodeConf.value.disabledDrag)
                return;
            dragFlag = true;
            const scrollWrap = scrollRef.value.wrapRef;
            const boxLeft = scrollWrap.getBoundingClientRect().left;
            const boxTop = scrollWrap.getBoundingClientRect().top;
            offsetLeft = evt.clientX - offsetX - boxLeft + scrollWrap.scrollLeft;
            offsetTop = evt.clientY - offsetY - boxTop + scrollWrap.scrollTop;
            window.requestAnimationFrame(() => {
                if (!draggableEl)
                    return;
                draggableEl.style.left = offsetLeft + 'px';
                draggableEl.style.top = offsetTop + 'px';
                draggableEl.style.opacity = '1';
                onDrag({
                    // offset: [offsetLeft + offsetX, offsetTop + offsetY], // 鼠标位置
                    offset: [offsetLeft, offsetTop],
                    sourceNode: moveNodeConf.value.sourceNode,
                });
            });
        };
        const doceNodeUp = evt => {
            evt.preventDefault();
            draggableEl && flowRef.value?.removeChild(draggableEl);
            draggableEl = null;
            dragFlag && onDragEnd();
            document.removeEventListener('mousemove', docNodeMove);
            document.removeEventListener('mouseup', doceNodeUp);
        };
        // 鼠标松开时添加连线
        const nodeMouseup = () => {
            if (!merge.value && !dragFlag) {
                emit('node-click', moveNodeConf.value.sourceNode);
            }
        };
        const nodeIntercept = node => {
            return () => outputIntercept.value(node, graph.value);
        };
        const menuItemSelect = () => {
            menuConf.value.visible = false;
        };
        const selectAllMaskMouseDown = evt => {
            moveAllConf.value.isMove = true;
            moveAllConf.value.origin = [...graph.value.origin];
            moveAllConf.value.downPosition = [evt.clientX, evt.clientY];
        };
        const toJSON = () => {
            return graph.value.toJSON();
        };
        const getMouseCoordinate = (clientX, clientY) => {
            const offset = getOffset({ clientX, clientY }, flowRef.value);
            return vector(offset).minus(graph.value.origin).end;
        };
        const addNode = options => {
            return graph.value.addNode(options);
        };
        const nodeDelete = node => {
            // deleteNode({
            //   nodeId: node.id,
            //   modelPathList: modelPathList.value,
            //   nodeList: nodeList.value,
            //   linkList: linkList.value,
            // });
            emit('node-delete', node);
        };
        const nodeShrink = node => {
            shrinkOrExpandNode({
                nodeId: node.id,
                nodeList: nodeList.value,
                modelPathList: modelPathList.value,
            });
            handlerShrinkNode();
        };
        const handlerShrinkNode = () => {
            renderNodeList.value = initShrinkNode({
                modelPathList: modelPathList.value,
                nodeList: nodeList.value,
            });
            graph.value.initNode(renderNodeList.value);
            graph.value.initLink(linkList.value);
        };
        const nodeSelect = ({ nodeId, isLastNode }) => {
            emit('node-select', { nodeId, isLastNode });
        };
        const linkSelect = activeId => {
            emit('link-select', activeId);
        };
        const menuClick = ({ type, key, node, link }) => {
            emit('menu-click', { type, key, node, link });
        };
        const updateNodeData = (node, newNode) => {
            Object.assign(node, newNode);
        };
        const rafRef = ref(null);
        const onDrag = ({ sourceNode, offset }) => {
            raf.cancel(rafRef.value);
            rafRef.value = raf(() => {
                const { node, direction } = findNodeByCoordinate({
                    nodeList: nodeList.value,
                    modelPathList: modelPathList.value,
                    offset,
                });
                const { disabled, startNode } = appendDragNode({
                    sourceNode,
                    direction,
                    targetNode: node,
                    nodeList: nodeList.value,
                    modelPathList: modelPathList.value,
                    linkList: linkList.value,
                });
                moveNodeConf.value.startNode = startNode;
                moveNodeConf.value.targetNode = node;
                moveNodeConf.value.direction = direction;
                moveNodeConf.value.disabledDragging = disabled;
            }, 5);
        };
        const onDragEnd = () => {
            raf.cancel(rafRef.value);
            rafRef.value = null;
            deleteDragNodeAndLink({
                nodeList: nodeList.value,
                linkList: linkList.value,
                modelPathList: modelPathList.value,
            });
            updateDragNode({
                sourceNode: moveNodeConf.value.sourceNode,
                startNode: moveNodeConf.value?.startNode,
                targetNode: moveNodeConf.value.targetNode,
                nodeList: nodeList.value,
                linkList: linkList.value,
                modelPathList: modelPathList.value,
                direction: moveNodeConf.value.direction,
                disabled: moveNodeConf.value.disabledDragging,
            });
            moveNodeConf.value.sourceNode = null;
            moveNodeConf.value.targetNode = null;
        };
        // 导出方法
        expose({
            menuItemSelect,
            selectAllMaskMouseDown,
            toJSON,
            getMouseCoordinate,
            addNode,
            mergeNode,
            cancelMerge,
            insertNode,
            deleteNode,
            appendNode,
            shrinkOrExpandNode,
            lightenPath,
            changeNodeHeight,
            checkMergeNodeList,
            editMerge,
        });
        return () => {
            // 绘制连线
            // const flowLine = () => {
            //   return line;
            // };
            const flowLine = [];
            if (graph.value.linkList?.length > 0) {
                graph.value.linkList.forEach((link, idx) => {
                    flowLine.push(<>
              <GraphLine index={idx} padding={linkPadding.value} graph={graph.value} link={link} merge={merge.value} key={link.key} selectedActiveId={selectedActiveId.value} link-base-style={linkBaseStyle.value} link-desc={linkDesc} link-style={linkStyle} linkSelect={linkSelect} menus={menus.value} menuClick={menuClick} readonly={readonly.value} getMenuPopupContainer={() => flowRef.value} nodeList={nodeList.value} modelPathList={modelPathList.value}/>
            </>);
                });
            }
            // 获取节点
            // const flowNode = () => {
            //   return node;
            // };
            const flowNode = [];
            if (graph.value.nodeList?.length > 0) {
                graph.value.nodeList.forEach((node, idx) => {
                    flowNode.push(<>
              <GraphNode index={idx} node={node} link-list={linkList.value} graph={graph.value} key={node.id} is-move={node === moveNodeConf.value.sourceNode} is-tem-edge={temEdgeConf.value.visible} node-intercept={nodeIntercept(node)} 
                    // line-drop={linkAddable.value}
                    node-drop={draggable.value} class-name={node.meta?.className} merge={merge.value} selected-node-id={selectedNodeId.value} nodeList={nodeList.value} modelPathList={modelPathList.value} nodeMousedown={nodeMousedown} nodeMouseup={nodeMouseup} nodeSelect={nodeSelect} nodeShrink={nodeShrink} nodeDelete={nodeDelete} onDrag={onDrag} onDragEnd={onDragEnd} menuClick={menuClick} menus={menus.value} readonly={readonly.value} scrollRef={scrollRef.value} dragging={node.meta?.extParam?.isDragging} getMenuPopupContainer={() => flowRef.value} v-slots={{
                            header: () => slots?.nodeHeader?.(node),
                            content: () => slots?.nodeContent?.(node),
                            tools: () => slots?.nodeToolsProps?.({ node, updateNodeData }),
                        }}/>
            </>);
                });
            }
            return (<ScrollBar ref={scrollRef} view-class={`${prefixCls.value}-view`}>
          <div class={classNames({
                    [`${prefixCls.value}`]: true,
                    [`${prefixCls.value}-readonly`]: readonly.value,
                    [`${prefixCls.value}-gu`]: quotationColor.value === QuotationColor.GREEN_UP_RED_DOWN,
                    [`${prefixCls.value}-merge`]: merge.value,
                })} ref={flowRef}>
            {flowLine}
            {flowNode}
          </div>
        </ScrollBar>);
        };
    },
});
export default withInstall(StgyFlow);
